import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { InputCurrency } from '@packages/shared/src/ui/Input/InputCurrency';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { Popover } from '@packages/shared';
import { cn } from '@packages/shared/src/utils/cn';
import { useFormContext } from 'react-hook-form';
import { furtherInformationMessages, generalFormMessages } from './messages';
import type { CreditCheckFormValues } from './schema';
import type { OpenDialogHandler } from './types';

export const messages = defineMessages({
  monthlyIncomeInputInfo: {
    id: 'CreditCheckForm.ShortFormSection.InputInfo',
    defaultMessage:
      'Naast je salaris of uitkering, kan je inkomen ook bestaan uit huuropbrengsten,lijfrenten of ontvangen alimentatie. Ook bonussen worden meegeteld. Neem het totale bonusbedrag dat je jaarlijks ontvangt en deel dit door 12 maanden.',
  },
});

type ShortFormSectionProps = {
  handleOpenDialog: OpenDialogHandler;
};

export const ShortFormSection: React.FC<ShortFormSectionProps> = ({ handleOpenDialog }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { formatMessage } = useIntl();
  const {
    register,
    formState: { errors },
  } = useFormContext<CreditCheckFormValues<'short'>>();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const popoutOpen = Boolean(anchorEl);
  const id = popoutOpen ? 'monthlyIncomeInfo' : undefined;
  return (
    <div className="flex flex-col gap-1.5" data-testid="short-form-section">
      <div className="flex items-center md:w-1/2">
        <InputCurrency
          {...register('secondPartForm.monthlyIncome')}
          label={formatMessage(furtherInformationMessages.monthlyIncome)}
          containerClassName="relative w-full"
          placeholder={formatMessage(generalFormMessages.inputPlaceholder)}
          error={!!errors?.secondPartForm?.monthlyIncome?.message}
          helperText={errors?.secondPartForm?.monthlyIncome?.message}
        />
        <Button
          type="button"
          variant="link"
          size="base"
          className={cn(
            'ml-1.5 rounded-full p-0',
            errors?.secondPartForm?.monthlyIncome?.message ? 'mt-0' : 'mt-2.5',
          )}
          onClick={handleClick}
        >
          <div className="icon-emp-information-circle hover:bg-color-primary bg-color-info size-4" />
        </Button>
        <Popover
          id={id}
          open={popoutOpen}
          anchorEl={anchorEl}
          disableScrollLock
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
        >
          <p className="text-size-body2 w-[20rem] p-2">
            {formatMessage(messages.monthlyIncomeInputInfo)}
          </p>
        </Popover>
      </div>
      <Button
        variant="link"
        size="base"
        className="text-size-body3 items-center justify-start px-0 py-0"
        onClick={(e) =>
          handleOpenDialog(
            furtherInformationMessages.monthlyIncome,
            furtherInformationMessages.monthlyIncomeDialogText,
            e,
          )
        }
      >
        {formatMessage(furtherInformationMessages.furtherInformationCardLink)}
      </Button>
      <div className="border-color-grey-dark rounded-md border border-opacity-50 p-1.5">
        {formatMessage(furtherInformationMessages.incomeDescription)}
      </div>
    </div>
  );
};
